export async function GetJsonWithToken<TResult>(
  url: string,
  options?: RequestInit,
): Promise<FetchResult<TResult>> {
  const token = GetToken();
  const opt: RequestInit = {
    cache: "no-store",
    headers: {
      "Authorization": "Bearer " + token,
      "Access-Control-Request-Method": "*",
      "Content-Type": "application/json",
    },
    method: "GET",
  };

  const response = await fetch(ParseApiPath(url), Object.assign(opt, options));
  const data = await response.json();

  return {
    data,
    response,
  };
}

export async function FetchWithToken(
  url: string,
  options?: RequestInit,
): Promise<FetchResultBase> {
  const token = GetToken();
  const opt: RequestInit = {
    cache: "no-store",
    headers: {
      "Authorization": "Bearer " + token,
      "Access-Control-Request-Method": "*",
      "Content-Type": "application/json",
    },
    method: "GET",
  };

  const response = await fetch(ParseApiPath(url), Object.assign(opt, options));

  return {
    response,
  };
}

export function ParseApiPath(url: string): string {
  const base = (process.env.VUE_APP_BASE_API_URL as string | undefined) || "";
  return new URL(url, base).toString();
}

export function GetToken(): string {
  return GetCookieToken() || GetParamsToken();
}

/** 取得設置於CookieToken */
function GetCookieToken(): string {
  const patton = /^(token=)(.*)/;

  const tokenCookie = document.cookie
    .split("; ")
    .find((keyvalue) => patton.test(keyvalue));

  if (!tokenCookie) return "";

  const m = tokenCookie.match(patton);

  return m ? m[2] : "";
}

/** 取得網址參數Token */
function GetParamsToken(): string {
  return new URL(document.URL).searchParams.get("token") ?? "";
}

export interface FetchResultBase {
  response: Response;
}

export interface FetchResult<T> extends FetchResultBase {
  data: T;
}
